import { EmployeeScore } from './employee-score';

export class EmployeeSalary extends EmployeeScore {
    deductions: number;
    reimbursements: number;
    hourlySalary: number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/employees/shared/models/employee-salary.ts